/* Emergency Fund Calculator — Ch. 22. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  class EmergencyFund {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = {
        housing: +u.h || 800, food: +u.f || 300, transport: +u.t || 100,
        utilities: +u.u || 100, other: +u.o || 100,
        stability: u.s || 'stable', current: +u.c || 0, monthly: +u.ms || 100
      };
      this.render(); this.bind(); this.update();
    }
    render() {
      var s = this.state;
      var fld = (label, key, val) => `
        <div class="sim-field">
          <label class="sim-field__label"><span>${label}</span><span class="val" data-display="${key}">${fmt(val)}</span></label>
          <input type="range" data-state="${key}" min="0" max="3000" step="25" value="${val}">
        </div>`;
      this.el.innerHTML = `
        <div class="sim-layout">
          <div class="sim-controls">
            ${fld('Housing/Rent',     'housing',   s.housing)}
            ${fld('Food',             'food',      s.food)}
            ${fld('Transport',        'transport', s.transport)}
            ${fld('Utilities/Phone',  'utilities', s.utilities)}
            ${fld('Other essentials', 'other',     s.other)}
            <div class="sim-field">
              <span class="sim-field__label">Income stability</span>
              <div class="sim-toggle" data-toggle="stability">
                <button data-val="stable"   class="${s.stability==='stable'?'is-active':''}">Stable</button>
                <button data-val="parttime" class="${s.stability==='parttime'?'is-active':''}">Part-time</button>
                <button data-val="freelance"class="${s.stability==='freelance'?'is-active':''}">Freelance</button>
              </div>
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Current savings</span><span class="val" data-display="current">${fmt(s.current)}</span></label>
              <input type="range" data-state="current" min="0" max="20000" step="50" value="${s.current}">
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Monthly savings</span><span class="val" data-display="monthly">${fmt(s.monthly)}</span></label>
              <input type="range" data-state="monthly" min="0" max="2000" step="25" value="${s.monthly}">
            </div>
          </div>

          <div class="sim-results">
            <div style="display:grid; grid-template-columns: 1fr 80px; gap: 24px;">
              <div>
                <div class="sim-result">
                  <div class="sim-result-label">Monthly essentials</div>
                  <div class="sim-result-primary" data-out="monthly_total">$0</div>
                </div>
                <div style="display:grid; grid-template-columns:1fr 1fr 1fr; gap:12px; margin-top:18px;">
                  <div class="sim-result"><div class="sim-result-label">Min (3 mo)</div><div style="font-family:var(--font-display); font-weight:700; font-size:20px;" data-out="min">$0</div></div>
                  <div class="sim-result"><div class="sim-result-label">Recommended</div><div style="font-family:var(--font-display); font-weight:700; font-size:20px;" data-out="rec">$0</div></div>
                  <div class="sim-result"><div class="sim-result-label">Max (6 mo)</div><div style="font-family:var(--font-display); font-weight:700; font-size:20px;" data-out="max">$0</div></div>
                </div>
                <div class="sim-insight" data-out="plan"></div>
                <div class="sim-insight">Without an emergency fund, a single $500 car repair forces most people into credit-card debt at 24% APR.</div>
                <div class="sim-insight">Your emergency fund IS your first investment — it prevents debt.</div>
              </div>
              <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
                <span class="label">YOUR FUND</span>
                <div class="sim-thermo"><div class="sim-thermo__fill" data-out="thermo" style="height:0%"></div></div>
                <span class="label" data-out="thermo_pct">0%</span>
              </div>
            </div>
          </div>
        </div>`;
    }
    bind() {
      this.el.querySelectorAll('input[data-state]').forEach(input => {
        input.addEventListener('input', () => {
          var k = input.dataset.state, v = +input.value;
          this.state[k] = v;
          var l = this.el.querySelector(`[data-display="${k}"]`);
          if (l) l.textContent = fmt(v);
          this.update();
        });
      });
      this.el.querySelectorAll('[data-toggle="stability"] button').forEach(b => {
        b.addEventListener('click', () => {
          this.state.stability = b.dataset.val;
          this.el.querySelectorAll('[data-toggle="stability"] button').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active');
          this.update();
        });
      });
    }
    update() {
      var s = this.state;
      var monthlyTotal = s.housing + s.food + s.transport + s.utilities + s.other;
      var multiplier = s.stability === 'stable' ? 3 : (s.stability === 'parttime' ? 4 : 6);
      var min = monthlyTotal * 3, rec = monthlyTotal * multiplier, max = monthlyTotal * 6;
      var monthsToTarget = s.monthly > 0 ? Math.ceil((rec - s.current) / s.monthly) : Infinity;

      var $ = q => this.el.querySelector(q);
      $('[data-out="monthly_total"]').textContent = fmt(monthlyTotal);
      $('[data-out="min"]').textContent = fmt(min);
      $('[data-out="rec"]').textContent = fmt(rec);
      $('[data-out="max"]').textContent = fmt(max);
      $('[data-out="plan"]').innerHTML = (s.current >= rec)
        ? `You’re fully covered. Anything beyond ${fmt(rec)} could be moved to long-term investing.`
        : `Save <strong>${fmt(s.monthly)}</strong>/month → reach your <strong>${fmt(rec)}</strong> target in <strong>${isFinite(monthsToTarget) ? monthsToTarget + ' months' : 'never (set monthly savings)'}</strong>.`;

      var pct = Math.min(100, (s.current / rec) * 100);
      $('[data-out="thermo"]').style.height = pct.toFixed(1) + '%';
      $('[data-out="thermo_pct"]').textContent = pct.toFixed(0) + '%';
      IT.url.write({ h: s.housing, f: s.food, t: s.transport, u: s.utilities, o: s.other, s: s.stability, c: s.current, ms: s.monthly });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new EmergencyFund('simulator-container'));
})();
